import { t as useSafeLayoutEffect } from "./use-safe-layout-effect-wcVibUML.js";
import { useCallback, useRef } from "react";
function useCallbackRef(r, i = []) {
	let a = useRef(r);
	return useSafeLayoutEffect(() => {
		a.current = r;
	}), useCallback(((...e) => a.current?.(...e)), i);
}
export { useCallbackRef as t };
